class PromoMessage {
  constructor(configElId = "promo-config-json", targetId = "drawer-promo-message") {
    this.target = document.getElementById(targetId);
    this.config = this.loadConfig(configElId);

    this.refresh();
    this.installListeners();
  }

  normalize(str) {
    return (str ?? "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  loadConfig(id) {
    const el = document.getElementById(id);
    try {
      return el ? JSON.parse(el.textContent) : {};
    } catch {
      return {};
    }
  }

  setText(msg) {
    if (!this.target) return;
    this.target.textContent = msg || "";
    this.target.style.display = msg ? "block" : "none";
  }

  update(cart) {
    const { criteria_a, criteria_b, message_a, message_b } = this.config;
    const a = criteria_a?.toLowerCase();
    const b = criteria_b?.toLowerCase();
    let hasA = false, hasB = false;

    for (const item of cart.items || []) {
      let cat = item?.properties?.category;
      if (Array.isArray(cat)) cat = cat[0];
      const n = this.normalize(cat);
      if (n === a) hasA = true;
      if (n === b) hasB = true;
      if (hasA && hasB) break;
    }

    if (hasA && !hasB) this.setText(message_a);
    else if (hasB && !hasA) this.setText(message_b);
    else this.setText("");
  }

  async refresh() {
    try {
      const cart = await fetch("/cart.js").then(r => r.json());
      this.update(cart);
    } catch (e) {
      console.warn("[PromoMessage] cart.js fetch error", e);
    }
  }

  installListeners() {
    const refreshBound = this.refresh.bind(this);

    ["cart:updated", "variant:changed", "cart:refresh"].forEach(ev =>
      document.addEventListener(ev, refreshBound)
    );
  }
}

document.addEventListener("DOMContentLoaded", () => new PromoMessage());
